// Mantine v7 ships styles as CSS (Emotion was removed in core). These imports
// must come before any component styles so the cascade resolves correctly.
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
// Global keyframes previously injected via the v6 theme.globalStyles option.
import '@dealstack/frontend/mantineGlobalStyles.css';

import { mantineTheme } from '@dealstack/frontend/shared/mechanism/styleguide/mantineTheme';
import { MantineProvider } from '@mantine/core';
import { emotionTransform, MantineEmotionProvider } from '@mantine/emotion';
import { type ReactNode } from 'react';

interface Props {
	children: ReactNode;
}

/**
 * Single source of truth for the app-wide Mantine configuration.
 *
 * All three entry points (app / admin / investor) render through this wrapper.
 *
 * `@mantine/emotion` is wired in here as a compatibility bridge: it restores the
 * v6-style `sx` / `styles` props (with nested selectors and pseudo-classes) that
 * the codebase relies on heavily, so we did not have to rewrite ~220 `sx` usages
 * during the v6 -> v7 migration. See https://mantine.dev/styles/emotion/
 */
export const AppMantineProvider = ({ children }: Props) => (
	<MantineProvider theme={mantineTheme.v1} stylesTransform={emotionTransform}>
		<MantineEmotionProvider>{children}</MantineEmotionProvider>
	</MantineProvider>
);
